import { AreaChart } from '@mantine/charts'
import { Box, Flex, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { useSsrContext } from '@/contexts/ssr'
import { CoinPrices } from '@/types/coin'

import { useShareAreaChartProps } from './hooks'
import { TICK_FONT_SIZE } from './utils'

interface ShareChartProps {
  currentCoinPrices?: CoinPrices
  curTimeRange: string
}

export default function ShareChart({ currentCoinPrices, curTimeRange }: ShareChartProps) {
  const shareAreaChartProps = useShareAreaChartProps({
    currentCoinPrices,
    curTimeRange,
  })
  const areaChart = currentCoinPrices ? <AreaChart {...shareAreaChartProps} /> : null
  const t = useTranslations()
  const { selectedCurrency } = useSsrContext()
  return (
    <Box>
      <Text variant={'body'} mb={12}>
        {t('chart.priceWithChart')}
      </Text>
      <Box bg={'#1a1a2e'} pt={8} px={6} w={160} h={160}>
        <Flex mb={8}>
          <Text
            style={{
              fontSize: TICK_FONT_SIZE,
            }}
            flex={1}
          >
            {t('common.price')} ({selectedCurrency})
          </Text>
          <Text
            style={{
              fontSize: TICK_FONT_SIZE,
            }}
          >
            {curTimeRange}
          </Text>
        </Flex>
        {areaChart}
      </Box>
    </Box>
  )
}
